<template>
  <v-container style="background-color: transparent;">
    <v-data-table
      :headers="columns"
      :items="rows"
    >
      <template v-slot:item.invoice.dueDate="{ item }">
        {{ formatDate(item.invoice.dueDate) }}
      </template>
      <template v-slot:item.pay="{ item }">
        <v-icon v-if="isCollateral(item)" style="margin-right: 5px" :disabled="item.payed" @click="buy(item)">
          arrow_downward
        </v-icon>
        <v-icon v-if="toPay(item)" style="margin-right: 5px" :disabled="item.payed" @click="payCollateral(item)">
          payments
        </v-icon>
        <div v-if="toreceiver(item)">
          <v-icon  v-if="item.gain > 0" style="margin-right: 5px" @click="recolect(item)">
            arrow_upward
          </v-icon>
          <v-icon v-if="item.itemMarket.outstandingAmount > 0" style="margin-right: 5px" @click="publishAMM(item)">
            attach_money
          </v-icon>
        </div>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>

import ApiRepository from "@/repositories/ApiRepository";
import moment from "moment";
import Hash from "object-hash";
import SmartRepository from "@/repositories/SmartRepository";
import Constants from "../../constants";

export default {
    data: () => {
        return {
            columns: [
                { text: 'Name', align: 'center', value: 'itemMarket.name', },
                { text: 'Date', align: 'center', value: 'invoice.dueDate',  },
                { text: 'To Pay', align: 'center', value: 'initialToPay',  sortable: true},
                { text: 'Quantity', align: 'center', value: 'count',  sortable: true},
                { text: 'Gain', align: 'center', value: 'gain',  sortable: true},
                { text: 'Pay', align: 'center', value: 'pay'}
            ],
            rows: [],
        };
    },
    created () {
    },
    mounted () {
        this.fetch();
    },
    methods: {
        row_classes (item) {
            if (item.type === 'collateral' && item.payed) {
                return "green";
            }
            if (item.type === 'toPay' && item.payed) {
                return "green";
            }
            if (item.type === 'toReceive' && item.payed) {
                return "yellow";
            }
        },
        fetch () {
            ApiRepository.getMyCollaterals()
                .then((res) => {
                    this.rows = res.data.collateral;
                    for (const row in this.rows) {
                        if (this.rows[row].type === 'toReceive') {
                            const mySTR = this.rows[row].factoring._id.toString();
                            const hash = '0x' + Hash.sha1(mySTR);
                            SmartRepository.call(Constants.contractMarketplace, "getAddress", [hash])
                                .then((invoiceAddress) => {
                                    const NFTX = Constants.contractNFTx;
                                    NFTX.address = invoiceAddress;
                                    SmartRepository.call(NFTX, "balanceTokens", [])
                                        .then((amount) => {
                                            this.rows[row].gain = SmartRepository.decodeEther(amount).toString();
                                        }).catch((e) => {
                                            let message = e.toString();
                                            if (e.message) {
                                                message = e.message;
                                            }
                                            if (e.data && e.data.message) {
                                                message = e.data.message;
                                            }
                                            this.$root.$emit('show-snackbar', {message: message, color: "error"});
                                        });
                                }).catch((e) => {
                                    let message = e.toString();
                                    if (e.message) {
                                        message = e.message;
                                    }
                                    if (e.data && e.data.message) {
                                        message = e.data.message;
                                    }
                                    console.log(message);
                                });
                            // si son TO RECEIVE I OUTSTANDING AMOUNT >= POTS PENJAR AL AMM
                            SmartRepository.call(Constants.contractMarketplace, "getOutstandingAmount", [hash])
                                .then((amount) => {
                                    console.log(SmartRepository.decodeEther(amount).toString());
                                    this.rows[row].itemMarket.outstandingAmount = SmartRepository.decodeEther(amount).toString();
                                }).catch((e) => {
                                    let message = e.toString();
                                    if (e.message) {
                                        message = e.message;
                                    }
                                    if (e.data && e.data.message) {
                                        message = e.data.message;
                                    }
                                    this.$root.$emit('show-snackbar', {message: message, color: "error"});
                                });
                        }
                    }
                    console.log(this.rows);
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        formatDate (date) {
            return moment(date).format('MMM D, YYYY' );
        },
        recolect (item) {
            this.$root.$emit('start-loading');
            const mySTR = item.factoring._id.toString();
            const hash = '0x' + Hash.sha1(mySTR);
            SmartRepository.call(Constants.contractMarketplace, "getAddress", [hash])
                .then((invoiceAddress) => {
                    console.log(invoiceAddress);
                    const NFTX = Constants.contractNFTx;
                    console.log(NFTX)
                    NFTX.address = invoiceAddress;
                    SmartRepository.transaction(NFTX, "receiveTokens", [SmartRepository.parseEther(item.gain)])
                        .then(() => {
                            this.$root.$emit('stop-loading');
                            this.$root.$emit('show-snackbar', {message: 'Collateral colected succesfully.'});
                            this.fetch();
                        }).catch((e) => {
                            console.log(e);
                            let message = e.toString();
                            if (e.message) {
                                message = e.message;
                            }
                            if (e.data && e.data.message) {
                                message = e.data.message;
                            }
                            this.$root.$emit('stop-loading');
                            this.$root.$emit('show-snackbar', {message: message, color: "error"});
                        });
                }).catch((e) => {
                    console.log(e);
                    let message = e.toString();
                    if (e.message) {
                        message = e.message;
                    }
                    if (e.data && e.data.message) {
                        message = e.data.message;
                    }
                    this.$root.$emit('stop-loading');
                    this.$root.$emit('show-snackbar', {message: message, color: "error"});
                });
        },
        buy (item) {
            const mySTR = item.factoring._id.toString();
            const hash = '0x' + Hash.sha1(mySTR);
            SmartRepository.call(Constants.contractMarketplace, "getOutstandingAmount", [hash])
                .then((res) => {
                    this.$root.$emit('show-payment-modal', {
                        title: this.$t('Add liquidity'),
                        message: this.$t('Message Add Liquidity'),
                        maxAmmount: SmartRepository.decodeEther(res),
                        factoringId: item.factoring._id,
                        yes: () => {
                            // fer refresh
                            this.fetch();
                        }
                    });
                })
                .catch((err) => {
                });
        },
        publishAMM (item) {
            this.$root.$emit('show-amm-modal', {
                title: this.$t('MyInvoices.CollectByppay'),
                message: this.$t('MyInvoices.PublishAMM'),
                factoring: item.factoring._id,
                yes: () => {
                    // fer refresh
                    this.fetch();
                }
            });
        },
        payCollateral (item) {
            //ANAR A PANTALLA PAGAMENT BYPPAY
            this.$router.push({name: 'viewInvoice', query: {invoiceId: item.invoice._id, byppay: item.factoring._id, tab: 2  }, replace: true});
        },
        isCollateral (item) {
            return item.type === 'collateral';
        },
        toPay (item) {
            return item.type === 'toPay';
        },
        toreceiver (item) {
            return item.type === 'toReceive';
        }
    },
};

</script>
<style>

</style>
